import {Button} from "./index";
import React from "react";

interface DeleteButtonProps {
    onDelete: () => void
    className?: string
    disabled?: boolean,
    destructive?: boolean
}

export const DeleteButton = ({onDelete, className = 'delete', disabled = false, destructive = true, ...rest}: DeleteButtonProps) =>
    <Button
        icon='left'
        iconName="close"
        kind="borderless"
        destructive={destructive}
        size='medium'
        className={className}
        {...rest}
        onClick={onDelete}
        disabled={disabled}
    />;

